import history from 'browser-history';

/**
 * History module wrapper for legacy pages.
 * This file used to contain all the routing logic.
 */
export default {
    history,
    go(url) {
        this.history.push(url);
    },
    url(url) {
        this.history.replace(url);
    }
};



// WEBPACK FOOTER //
// ./web/js/routing.js